export default __webpack_public_path__ + "7981c46b4beca3560c38d1606da83b51.png";